import { create } from 'zustand';

interface LayoutState {
  // State
  hideBottomNav: boolean;
  disableLocationSelection: boolean;
  
  // Actions
  setHideBottomNav: (value: boolean) => void;
  setDisableLocationSelection: (value: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  // Initial state
  hideBottomNav: false,
  disableLocationSelection: false,
  
  // Actions
  setHideBottomNav: (value) => set({ hideBottomNav: value }),
  setDisableLocationSelection: (value) => set({ disableLocationSelection: value }),
})); 